module.exports = __webpack_public_path__ + "static/media/bar-chart.bd44226e.svg";